module.exports = __webpack_public_path__ + "static/media/37.d6ecd354.jpg";